import React from 'react'

import { HiOutlineArrowTopRightOnSquare } from 'react-icons/hi2'

import { useAuthInfo } from '@sweetauth/core'

import Link from '@/components/common/Link'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/common/TooltipV3'

import { DEMO_URL } from '@/constants/general'

import { useActiveOrgId } from '@/hooks/organization/useActiveOrgId'
import { useDefaultOrganization } from '@/hooks/organization/useDefaultOrganization'

interface DemoTooltipProps {
  asChild?: boolean
  childrenOnly?: boolean
  children?: React.ReactNode
  align?: 'start' | 'center' | 'end'
  alignOffset?: number
  side?: 'top' | 'bottom' | 'left' | 'right'
  sideOffset?: number
}

const DemoTooltip: React.FC<DemoTooltipProps> = ({
  asChild,
  children,
  childrenOnly = false,
  ...props
}) => {
  const { activeOrgId } = useActiveOrgId()
  const { data: defaultOrg, isLoading: isLoadingDefaultOrg } =
    useDefaultOrganization()
  const { user } = useAuthInfo()

  const isSignedIn = activeOrgId !== '' && user !== undefined && user !== null

  const isLoading = isLoadingDefaultOrg || defaultOrg === undefined

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild={asChild ?? true}>{children}</TooltipTrigger>
      {!childrenOnly &&
        !isLoading &&
        (isSignedIn ? (
          <TooltipContent inverseColors={true} {...props}>
            <div className="flex flex-col">
              <Link
                href={DEMO_URL}
                className="flex items-center gap-x-1 text-blue-600 dark:text-blue-400 hover:opacity-100 hover:underline underline-offset-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <HiOutlineArrowTopRightOnSquare className="flex-shrink-0 w-4 h-4" />
                Book a demo
              </Link>
            </div>
          </TooltipContent>
        ) : (
          <TooltipContent>Please sign in</TooltipContent>
        ))}
    </Tooltip>
  )
}

export default DemoTooltip
